import React from 'react';
import { Dialog } from 'react-weui';

export class AppInteractiveLectureTip extends React.Component {
  state = {
    isShow: false
  }

  show() {
    this.setState({ isShow: true })
  }

  hide() {
    this.setState({ isShow: false })
  }

  render() {
    const buttons = [
      {
        label: '确定',
        onClick: this.hide.bind(this)
      }
    ]
    return (
      <Dialog show={ this.state.isShow } buttons={ buttons } type="ios">
        本课程目前仅支持荔枝微课公众号听课，暂时无法在App收听哦
      </Dialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/appInteractiveLectureTip/index.js